import { render, staticRenderFns } from "./MakMore.vue?vue&type=template&id=5b6e2ffe&"
import script from "./MakMore.vue?vue&type=script&lang=js&"
export * from "./MakMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports